// extracted by mini-css-extract-plugin
export var divider = "_hg-7";
export var itemsToggle = "_hg-8";
export var mergeModal = "_hg-1";
export var optionCard = "_hg-4";
export var radioGroup = "_hg-6";
export var radioOption = "_hg-0";
export var selected = "_hg-5";
export var shipmentOptions = "_hg-2";
export var tableOptions = "_hg-3";